import ButtonIcon from "#common/buttons/ButtonIcon"
import ChipStatus from "#competence/components/ChipStatus"
import { UseContextsCompetence } from "#competence/contexts/ContextsCompetence"
import { Category, Edit } from "@mui/icons-material"
import CancelIcon from "@mui/icons-material/Cancel"
import { Box, Chip, Paper, Typography } from "@mui/material"
import { Fragment, useState } from "react"
import CompetenceForm from "../CompetenceForm"
import CompetenceInfoDelete from "./CompetenceInfoDelete"

export function CompetenceInfoHeader() {
	const { competence } = UseContextsCompetence()
	const [open, setOpen] = useState(false)
	return (
		<Paper elevation={1} sx={{ p: 3, mb: 3 }}>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "flex-start",
				}}
			>
				<Box>
					<Typography variant="h4" component="h1" gutterBottom>
						{competence.name}
					</Typography>
					<Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
						<Chip
							icon={<Category />}
							label={competence.category_name}
							// color={competence.active ? "success" : "error"}
							size="small"
						/>
						<ChipStatus active={competence.active} />
					</Box>
				</Box>
				<Box sx={{ display: "flex", gap: 1 }}>
					{competence.active && (
						<Fragment>
							<ButtonIcon
								title="Editar Competencia"
								icon={<Edit />}
								onClick={() => setOpen("edit")}
							/>
							<ButtonIcon
								title="Desactivar Competencia"
								icon={<CancelIcon color="error" />}
								onClick={() => setOpen("delete")}
							/>
						</Fragment>
					)}
				</Box>
			</Box>
			<CompetenceForm
				open={open === "edit"}
				setOpen={setOpen}
				competence={competence}
				refresh={() => {}}
			/>
			<CompetenceInfoDelete setOpen={setOpen} open={open === "delete"} />
		</Paper>
	)
}
